import { isIOS } from './isIOS';
import { isAndroid } from './isAndroid';
import isTablet from './isTablet';

export const isMobile = () => (isAndroid() || isIOS()) && !isTablet();
